module.exports = __webpack_public_path__ + "img/element-banner2-right.24da299e.jpg";